import { TRPCClientError } from '@trpc/client';
import { ErrorType } from '~/types/error';

export type ErrorMapItem = {
  type: ErrorType;
  message: string;
  title?: string;
};

export const getNotificationDataByMap = (
  i18n: ReturnType<typeof useI18n> = {},
  errorMap: ErrorMapItem[],
  error: Error,
  fallback?: { message?: string; title?: string }
) => {
  const data = errorMap.find(
    (item) =>
      error instanceof TRPCClientError &&
      (error.data?.zodError?.includes(item.type) || item.type === error.message)
  );

  const message =
    data?.message ||
    fallback?.message ||
    i18n.t('error-messages.please-contact-key-account-manager');

  const title =
    data?.title ||
    fallback?.title ||
    i18n.t('error-messages.something-went-wrong');
  return {
    message,
    title,
  };
};

export const getGeneralErrorMap = (
  i18n: ReturnType<typeof useI18n> = {}
): ErrorMapItem[] => {
  return [
    {
      type: ErrorType.NAME_ALREADY_EXISTS,
      message: i18n.t('error-messages.name-already-exists-message'),
      title: i18n.t('error-messages.name-already-exists-title'),
    },
    {
      type: ErrorType.NAME_IS_MANDATORY,
      message: i18n.t('error-messages.error-type.name-is-mandatory-message'),
      title: i18n.t('error-messages.incomplete-information'),
    },
  ];
};
